var _ellipse, _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectFun11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.0363,
    cy: 70.4033,
    rx: 35.2028,
    ry: 5.40329,
    fill: "#2E2E2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7322 45.828C63.9012 46.04 64 46.3075 64 46.5952V61.7381C64 62.4347 63.4176 63 62.7 63H41.9C41.1824 63 40.6 62.4347 40.6 61.7381V36.5C40.6 35.8034 41.1824 35.2381 41.9 35.2381H54.9C55.1418 35.2381 55.368 35.3012 55.5604 35.4122C55.6852 35.4854 55.7996 35.5763 55.8958 35.6899C55.914 35.71 55.9322 35.7328 55.9478 35.753L63.7322 45.828ZM53.6 37.7619H43.2V60.4762H61.4V47.8571H54.9C54.1824 47.8571 53.6 47.2918 53.6 46.5952V37.7619ZM58.8 56.6905C58.8 55.9939 58.2176 55.4286 57.5 55.4286H47.1C46.3824 55.4286 45.8 55.9939 45.8 56.6905C45.8 57.3871 46.3824 57.9524 47.1 57.9524H57.5C58.2176 57.9524 58.8 57.3871 58.8 56.6905ZM19.8 50.381H18.5C18.0502 50.381 17.6316 50.1538 17.395 49.7828C17.1584 49.4093 17.135 48.9449 17.3378 48.5537L19.9378 43.5061C20.1562 43.0796 20.6086 42.8095 21.1 42.8095C21.5914 42.8095 22.0438 43.0796 22.2622 43.5061L24.8622 48.5537C25.065 48.9449 25.0416 49.4093 24.805 49.7828C24.5684 50.1538 24.1498 50.381 23.7 50.381H22.4V52.9048H32.8C33.5176 52.9048 34.1 53.4701 34.1 54.1667C34.1 54.8632 33.5176 55.4286 32.8 55.4286H21.1C20.3824 55.4286 19.8 54.8632 19.8 54.1667V50.381ZM58.8 51.6429C58.8 50.9463 58.2176 50.381 57.5 50.381H47.1C46.3824 50.381 45.8 50.9463 45.8 51.6429C45.8 52.3394 46.3824 52.9048 47.1 52.9048H57.5C58.2176 52.9048 58.8 52.3394 58.8 51.6429ZM60.1 45.3333L56.2 40.2857V45.3333H60.1ZM35.1322 20.5899C35.3012 20.8019 35.4 21.0694 35.4 21.3571V36.5C35.4 37.1966 34.8176 37.7619 34.1 37.7619H23.7H13.3C12.5824 37.7619 12 37.1966 12 36.5V11.2619C12 10.5653 12.5824 10 13.3 10H26.3C26.5418 10 26.768 10.0631 26.9604 10.1741C27.0852 10.2473 27.1996 10.3382 27.2958 10.4518C27.314 10.472 27.3322 10.4947 27.3478 10.5149L35.1322 20.5899ZM25 12.5238H14.6V35.2381H32.8V22.619H26.3C25.5824 22.619 25 22.0537 25 21.3571V12.5238ZM30.2 31.4524C30.2 30.7558 29.6176 30.1905 28.9 30.1905H18.5C17.7824 30.1905 17.2 30.7558 17.2 31.4524C17.2 32.149 17.7824 32.7143 18.5 32.7143H28.9C29.6176 32.7143 30.2 32.149 30.2 31.4524ZM51 22.619V20.0952H40.6C39.8824 20.0952 39.3 19.5299 39.3 18.8333C39.3 18.1368 39.8824 17.5714 40.6 17.5714H52.3C53.0176 17.5714 53.6 18.1368 53.6 18.8333V22.619H54.9C55.3498 22.619 55.7684 22.8462 56.005 23.2172C56.2416 23.5907 56.265 24.0551 56.0622 24.4463L53.4622 29.4939C53.2438 29.9204 52.7914 30.1905 52.3 30.1905C51.8086 30.1905 51.3562 29.9204 51.1378 29.4939L48.5378 24.4463C48.335 24.0551 48.3584 23.5907 48.595 23.2172C48.8316 22.8462 49.2502 22.619 49.7 22.619H51ZM30.2 26.4048C30.2 25.7082 29.6176 25.1429 28.9 25.1429H18.5C17.7824 25.1429 17.2 25.7082 17.2 26.4048C17.2 27.1013 17.7824 27.6667 18.5 27.6667H28.9C29.6176 27.6667 30.2 27.1013 30.2 26.4048ZM27.6 20.0952H31.5L27.6 15.0476V20.0952Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 25,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#00B840"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 30,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#00B840"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 50,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#00B840"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 55,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#00B840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFun11);
export default __webpack_public_path__ + "static/media/selectFun11.6009ed6d427f63f602717bf549233c04.svg";
export { ForwardRef as ReactComponent };